export default __webpack_public_path__ + "static/media/reaper.abc3cbbf.webp";